import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Manufacturer } from '../../../../classes/Manufacturer';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';

@Component({
  selector: 'app-manufacturer',
  templateUrl: './manufacturer.component.html',
  styleUrls: ['./manufacturer.component.css']
})
export class ManufacturerComponent implements OnInit {

  id: number;
  contentVisible: boolean = false;
  manufacturerData: Manufacturer = new Manufacturer( );

  availableRoles: string[] = [ 'admin' ];
  isAvailable: boolean = true;

  constructor ( 
    private route: ActivatedRoute, 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Manufacturer Details' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {
    this.route.params.subscribe(params => {
       this.id = +params['id'];
       this.model.getManufacturerDataByID( this.id, ( manufacturer ) => {
         this.contentVisible = true;
         this.manufacturerData = manufacturer;
       });
    });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/manufacturers/manufacturer/manufacturer.component.ts